import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./Pages/Roles/Admin/Organisation/LiveView/Styles/LiveViewStyles.css";
import "./commonTheme.tsx";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import "suneditor/dist/css/suneditor.min.css";

import { MuiPickersUtilsProvider } from "@material-ui/pickers";

import DateFnsUtils from "@date-io/date-fns";

import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import store from "./Redux/store";
import { CssBaseline, ThemeProvider } from "@material-ui/core";
import { commonTheme } from "./commonTheme";
import { UploadFilesComponentProvider } from "./Components/FormGenerator/context/UploadFilesComponentContext";
import { QueryClientProvider, QueryClient } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";

// Commenting the persist logic as it fails to clear data on browser refresh or session break
const persistedStore = persistStore(store);
export const queryClient = new QueryClient();
ReactDOM.render(
  <Provider store={store}>
    {/* <PersistGate loading={null} persistor={persistedStore}> */}
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={commonTheme}>
        <CssBaseline />
        <UploadFilesComponentProvider>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <App />
          </MuiPickersUtilsProvider>
        </UploadFilesComponentProvider>
      </ThemeProvider>
      {/* </PersistGate> */}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
